import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IWorktask } from '@shared/services/worktask.service';

@Component({
	selector: 'app-mes-qr-component',
	templateUrl: './mes-qr-component.component.html',
	styleUrls: ['./mes-qr-component.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MesQrComponentComponent implements OnInit {
	@Input() workTaskName = '';
	@Input() workTaskKey = '';
	@Input() workTaskId = '';

	@Input() size = 0;

	@Output() qrClickEvent = new EventEmitter<IWorktask>();

	constructor() {}

	qrUrl = '';

	ngOnInit(): void {
		this.qrUrl = `https://chart.googleapis.com/chart?cht=qr&chl=${this.workTaskKey}&chs=${this.size !== 0 ? this.size : '200'}x${this.size !== 0 ? this.size : '200'}&choe=UTF-8`;
	}

	onQrClick(workTaskId: string, workTaskName: string) {
		const workTask = <IWorktask>{};

		workTask.id = workTaskId;
		workTask.name = workTaskName;

		this.qrClickEvent.emit(workTask);
	}
}
